module.exports = __webpack_public_path__ + "img/Avery Dennison.e04b896e.jpg";